import type { ApolloError } from '@apollo/client'
import type { ReactElement } from 'react'

import React from 'react'
import { errorCodeToMessage } from './errors'

import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import { Notification, toaster } from 'rsuite'

export const notify = (title: string, description?: string | ReactElement) =>
  toaster.push(
    <Notification type="info" header={title}>
      {description}
    </Notification>,
    { placement: 'topEnd' }
  )

export const notifyOk = (title: string, description?: string | ReactElement) =>
  toaster.push(
    <Notification type="success" header={title}>
      {description}
    </Notification>,
    { placement: 'topEnd' }
  )

export const notifyWarning = (
  title: string,
  description?: string | ReactElement
) =>
  toaster.push(
    <Notification type="warning" header={title}>
      {description}
    </Notification>,
    { placement: 'topEnd' }
  )

export const notifyError = (
  title: string,
  description?: string | ReactElement
) =>
  toaster.push(
    <Notification type="error" header={title}>
      {description}
    </Notification>,
    { placement: 'topEnd' }
  )

export const makeErrorNotification = (title?: string) => (error: Error) =>
  notifyError(title ?? 'Ошибка обновления заказа', error.message)

export const notifyGraphQLError = (title: string, error: ApolloError) => {
  const messages =
    error.graphQLErrors?.flatMap((gqlError) => {
      if (Array.isArray(gqlError.message)) {
        return gqlError.message.map((error) =>
          errorCodeToMessage(gqlError.code, error.message)
        )
      }
      return errorCodeToMessage(gqlError.code, gqlError.message)
    }) ?? []

  notifyError(
    title ?? 'Не удалось выполнить запрос',
    messages.length > 0 ? (
      <ul>
        {messages.map((message) => (
          <li>{message}</li>
        ))}
      </ul>
    ) : (
      <p>{error.message}</p>
    )
  )
}

export const makeGraphQLErrorNotification =
  (title: string = '') =>
    (error: ApolloError) =>
      notifyGraphQLError(title, error)
